import type { ThemePreset } from "../types";

export const rose: ThemePreset = {
  id: "rose",
  name: "Rosé",
  nameKey: "admin.settings.appearance.themes.rose.name",
  description: "Warme Rosa- und Mauve-Töne",
  descriptionKey: "admin.settings.appearance.themes.rose.description",
  light: {
    background: "oklch(0.985 0.005 350)",
    foreground: "oklch(0.15 0.015 350)",
    card: "oklch(1 0 0)",
    "card-foreground": "oklch(0.15 0.015 350)",
    popover: "oklch(1 0 0)",
    "popover-foreground": "oklch(0.15 0.015 350)",
    primary: "oklch(0.55 0.15 350)",
    "primary-foreground": "oklch(0.985 0 0)",
    secondary: "oklch(0.95 0.02 340)",
    "secondary-foreground": "oklch(0.22 0.015 350)",
    muted: "oklch(0.95 0.015 345)",
    "muted-foreground": "oklch(0.50 0.02 350)",
    accent: "oklch(0.93 0.025 340)",
    "accent-foreground": "oklch(0.22 0.015 350)",
    destructive: "oklch(0.577 0.245 27.325)",
    "destructive-foreground": "oklch(0.985 0 0)",
    border: "oklch(0.91 0.015 345)",
    input: "oklch(0.91 0.015 345)",
    ring: "oklch(0.55 0.15 350)",
    "sidebar-background": "oklch(0.98 0.008 345)",
    "sidebar-foreground": "oklch(0.30 0.015 350)",
    "sidebar-primary": "oklch(0.55 0.15 350)",
    "sidebar-primary-foreground": "oklch(0.985 0 0)",
    "sidebar-accent": "oklch(0.93 0.02 340)",
    "sidebar-accent-foreground": "oklch(0.22 0.015 350)",
    "sidebar-border": "oklch(0.91 0.015 345)",
    "sidebar-ring": "oklch(0.55 0.15 350)",
  },
  dark: {
    background: "oklch(0.17 0.015 350)",
    foreground: "oklch(0.92 0.01 345)",
    card: "oklch(0.20 0.015 350)",
    "card-foreground": "oklch(0.92 0.01 345)",
    popover: "oklch(0.20 0.015 350)",
    "popover-foreground": "oklch(0.92 0.01 345)",
    primary: "oklch(0.68 0.13 350)",
    "primary-foreground": "oklch(0.15 0.015 350)",
    secondary: "oklch(0.25 0.02 350)",
    "secondary-foreground": "oklch(0.90 0.01 345)",
    muted: "oklch(0.25 0.015 350)",
    "muted-foreground": "oklch(0.65 0.02 345)",
    accent: "oklch(0.28 0.02 345)",
    "accent-foreground": "oklch(0.92 0.01 345)",
    destructive: "oklch(0.55 0.22 27)",
    "destructive-foreground": "oklch(0.98 0 0)",
    border: "oklch(0.30 0.015 350)",
    input: "oklch(0.30 0.015 350)",
    ring: "oklch(0.68 0.13 350)",
    "sidebar-background": "oklch(0.14 0.015 350)",
    "sidebar-foreground": "oklch(0.82 0.012 345)",
    "sidebar-primary": "oklch(0.68 0.13 350)",
    "sidebar-primary-foreground": "oklch(0.15 0.015 350)",
    "sidebar-accent": "oklch(0.22 0.02 350)",
    "sidebar-accent-foreground": "oklch(0.92 0.01 345)",
    "sidebar-border": "oklch(0.28 0.015 350)",
    "sidebar-ring": "oklch(0.68 0.13 350)",
  },
};
